
import React from 'react';
import { SimpleGrid, Text } from '@mantine/core';
import { Customer } from '@/lib/api/types';
import CustomerCard from './CustomerCard';

interface CustomerSelectionGridProps {
  customers: Array<Customer & { stats?: any }>;
  onSelectCustomer: (customer: Customer) => void;
  isLoading: boolean;
  loadingCustomerId: string | null;
  isLoadingStats: boolean;
  lastActiveCustomerId?: string;
}

const CustomerSelectionGrid: React.FC<CustomerSelectionGridProps> = ({
  customers,
  onSelectCustomer,
  isLoading,
  loadingCustomerId,
  isLoadingStats,
  lastActiveCustomerId
}) => {
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <SimpleGrid cols={{ base: 1, md: 2, lg: 3 }} spacing="xl" style={{ maxWidth: 1152 }}>
        {customers.map((customer) => (
          <div key={customer.id} style={{ width: '100%', maxWidth: 384 }}>
            <CustomerCard
              customer={customer}
              onSelect={onSelectCustomer}
              isLoading={isLoading && loadingCustomerId === customer.id}
              showStats={true}
              isLastActive={customer.id === lastActiveCustomerId}
            />
          </div>
        ))}
      </SimpleGrid>
      {isLoadingStats && (
        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <Text size="sm" c="dimmed">Loading customer statistics...</Text>
        </div>
      )}
    </div>
  );
};

export default CustomerSelectionGrid;
